import { ContactType } from '../../contact/contact.type';
import { ScimScope } from './scim.scope';

export const SCIM_SCOPE_PARENT_TYPES: Record<ScimScope, ContactType[] | null> = {
    [ScimScope.Employee]: null,
    [ScimScope.Customer]: [
        ContactType.ServiceProvider,
        ContactType.Individual,
        ContactType.Business,
    ],
    [ScimScope.Contractor]: [
        ContactType.Subcontractor,
    ],
};
